import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { Log } from '@common/log-manager';
import { FullLookBookComponentType, TextOverFlowCss } from '@domains/storehome-common';

import { useLookbookService } from '../services/useLookbookService';

interface Props {
  component: FullLookBookComponentType;
  log?: Partial<Log>;
}

export const FullLookbookContainer = ({ component, log }: Props) => {
  const { common_title, common_image, landing_url } = component;
  const { moveToCollectionPage } = useLookbookService({ log });
  const titles = common_title.text.split('\n');

  return (
    <Root>
      <Container onClick={() => moveToCollectionPage(landing_url)}>
        <Image src={common_image?.url.normal} alt='look book image' />
        <TitleWrapper>
          <Text variant='Body_18_SemiBold' color='textStrong' css={TextOverFlowCss}>
            {titles[0]}
          </Text>
          {titles[1] && (
            <Text variant='Body_18_SemiBold' color='textStrong' css={TextOverFlowCss}>
              {titles[1]}
            </Text>
          )}
        </TitleWrapper>
      </Container>
    </Root>
  );
};

const Root = styled.section`
  padding: 12px 0 10px;
`;

const Container = styled.div`
  position: relative;
  cursor: pointer;
`;

const Image = styled.img`
  width: 100%;
  aspect-ratio: 1 / 0.7;
  object-fit: cover;
  object-position: center;
`;

const TitleWrapper = styled.div`
  width: calc(100% - 16px);
  position: relative;
  padding: 12px 16px;
  top: -20px;
  left: 16px;
  background-color: ${vars.color.staticWhite};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
